<template>
  <nav class="cm-sub-top-nav">
    <div class="cm-container">
      <div class="cm-sub-crumbs">
        <i @click="routeCli" class="cm-sub-icon">courseMo首页</i>
        <span>
          <a href="/">自测系统 </a>> 
          <a href="/">{{gradeInfo.name}} {{subject.name}}</a> > 
          <a href="javascript:">{{$route.meta.title}}</a>
        </span>
      </div>
      <div class="topic-name">
        {{title}}
        <button class="submit text-center" @click="cb" v-if="showSubmit">{{text}}</button>
      </div>
    </div>
  </nav>
</template>
<script>
import Storage from "../service/storage";
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '提交'
    },
    showSubmit: {
      type: Boolean,
      default: true,
    },
    cb: {
      type: Function,
      default: ()=>{}
    }
  },
  data () {
    return {
      gradeInfo: {},
      subject: {}
    }
  },
  created(){
    this.gradeInfo = Storage.get('currentGradeInfo');
    this.subject = Storage.get('currentSubject');
  },
  methods: {
    routeCli(){
      window.location.href = 'https://www.coursemo.com/index.html'
    }
  }
}
</script>
